import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CATEGORIES, FLEET } from "@/data/fleet";
import { VehicleCard } from "./VehicleCard";
import { EASE } from "@/components/motion/Reveal";

const FILTERS = [{ slug: "tutti", name: "Tutti" }, ...Object.values(CATEGORIES)];

export const FleetGrid = ({ fixedCategory }) => {
  const [filter, setFilter] = useState(fixedCategory || "tutti");
  const list = FLEET.filter((v) => filter === "tutti" || v.category === filter);

  return (
    <div data-testid="fleet-grid">
      {!fixedCategory && (
        <div className="flex flex-wrap items-center gap-2" data-testid="fleet-filters">
          {FILTERS.map((f) => {
            const active = filter === f.slug;
            return (
              <button
                key={f.slug}
                onClick={() => setFilter(f.slug)}
                data-testid={`fleet-filter-${f.slug}`}
                className={`relative px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider transition-colors duration-300 ${active ? "text-white" : "text-ink/60 hover:text-ink"}`}
              >
                {active && <motion.span layoutId="fleet-filter-pill" className="absolute inset-0 bg-ink" transition={{ duration: 0.4, ease: EASE }} />}
                <span className="relative">{f.name}</span>
                <span className={`relative ml-2 font-mono text-[10px] ${active ? "text-blue-500" : "text-ink/40"}`}>
                  {f.slug === "tutti" ? FLEET.length : FLEET.filter((v) => v.category === f.slug).length}
                </span>
              </button>
            );
          })}
        </div>
      )}
      <motion.div layout className={`grid gap-5 sm:grid-cols-2 lg:grid-cols-3 ${fixedCategory ? "" : "mt-10"}`}>
        <AnimatePresence mode="popLayout">
          {list.map((v, i) => (
            <motion.div
              key={v.slug}
              layout
              initial={{ opacity: 0, y: 30, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.55, delay: i * 0.04, ease: EASE }}
            >
              <VehicleCard vehicle={v} />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};
